<template>
<widget title="Scheduled Employees">
	<job-schedule-timeline :service-id="serviceId" :project-id="projectId" v-on:scheduleDaysSet="$emit('scheduleDaysSet',$event)"></job-schedule-timeline>
	<div v-if="jobType in $store && $store[jobType]" class="text-center">
		<a :href="'/schedule-timeline/'+jobType+'/'+$store[jobType].slug"
			target="_blank"
			class="btn btn-light">
			Full Schedule Timeline
		</a>
	</div>
</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import JobScheduleTimeline from "@/components/super_components/JobScheduleTimeline"

export default {
	name: "JobScheduleTimelineWidget",
	components: {
		Widget,
		JobScheduleTimeline
	},
	props: ["serviceId","projectId"],
	computed: {
		jobType() {
			if (this.serviceId)
				return "service"
			else
				return "project"
		},
	}
}
</script>